module.exports = __webpack_public_path__ + "static/media/scot-bilt-logo.e5d4b074.png";